module.exports = __webpack_public_path__ + "img/FullMoonFace.031f8b96.svg";